export const toSentenceCase = (str: string) =>
  str.replace(/\w\S*/g, (txt) => {
    const text = txt.replace('_', ' ');
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  });

export const toSentenceUpperCase = (str: string) =>
  str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export function nameToCamelCase({ name, separator }: { name: string; separator: string }) {
  const nameList = name.split(separator);
  if (nameList.length === 1) {
    return name;
  }
  let normalizedName = '';
  for (let i = 0; i < nameList.length; i += 1) {
    if (i === 0) {
      normalizedName += nameList[i];
    } else {
      normalizedName += nameList[i][0].toUpperCase() + nameList[i].slice(1);
    }
  }
  return normalizedName;
}

export function camelCaseSplitToUpperCase(str: string) {
  const strUpgraded = str
    .split('')
    .map((character, index) => {
      if (index === 0) {
        return character.toUpperCase();
      }
      if (index !== 0 && character.toUpperCase() === character) {
        return ` ${character}`;
      }
      return character;
    })
    .join('');

  return strUpgraded;
}
